module.exports = __webpack_public_path__ + "static/media/Aws.eac803d4.png";